module.exports = __webpack_public_path__ + "static/media/Direct_Messaging.1ba75f43.png";